import { useEffect, useRef } from 'react';

// Endereços do HUB: /<módulo>/<item>/<detalhe> (ex.: /projetos/<id>, /formacoes/<id>/ficha, /comercial/orcamento/<id>).
// Cada módulo mantém a barra de endereço igual ao que está aberto, para o F5, o «para trás» e a partilha de links.

// partes do caminho atual, já descodificadas: '/formacoes/abc/ficha' → ['formacoes','abc','ficha']
export const segmentosRota = () => window.location.pathname.split('/').filter(Boolean).map(s => { try { return decodeURIComponent(s); } catch (_) { return s; } });

// muda a barra sem recarregar. Só mexe se o módulo atual for o indicado (a 1.ª parte do caminho),
// para um módulo que ainda está a fechar não estragar o endereço do seguinte.
export function irPara(caminho, { modulo, substituir = false } = {}) {
  if (modulo && segmentosRota()[0] !== modulo) return;
  const atual = window.location.pathname;
  if (atual === caminho) return;
  // os parâmetros antigos (?orc=, ?id=…) já foram lidos pelo módulo: não passam para o novo endereço
  window.history[substituir ? 'replaceState' : 'pushState']({}, '', caminho + window.location.hash);
}

// «para trás» / «para a frente» do browser
export function useAoVoltar(fn) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    const h = () => ref.current();
    window.addEventListener('popstate', h);
    return () => window.removeEventListener('popstate', h);
  }, []);
}
